export const asyncWrapper = promise => (
    promise
        .then(data => ({ data, error: null }))
        .catch(error => ({ error, data: null }))
);



// WEBPACK FOOTER //
// ./src/_helpers/async.helper.js